<script lang="ts">
    import { AvailabilityStatus } from "@workadventure/messages";
    import { resetAllStatusStoreExcept } from "../../../Rules/StatusRules/statusChangerFunctions";
    import type { RequestedStatus } from "../../../Rules/StatusRules/statusRules";
    import { availabilityStatusStore } from "../../../Stores/MediaStore";
    import { getColorHexOfStatus, getStatusLabel } from "../../../Utils/AvailabilityStatus";
    import LL from "../../../../i18n/i18n-svelte";
    import ExternalComponents from "../../ExternalModules/ExternalComponents.svelte";
    import HeaderMenuItem from "../MenuIcons/HeaderMenuItem.svelte";
    import { openedMenuStore } from "../../../Stores/MenuStore";
    import type { StatusInformationInterface } from "./Interfaces/AvailabilityStatusPropsInterface";
    import AvailabilityStatusCircle from "./AvailabilityStatusCircle.svelte";
    import { IconCheck } from "@wa-icons";

    interface Props {
        statusInformation: Array<StatusInformationInterface>;
        align?: "end" | "start";
    }

    let { statusInformation, align = "start" }: Props = $props();

    const handleKeyPress = (e: KeyboardEvent, newStatus: RequestedStatus | AvailabilityStatus.ONLINE | null) => {
        if (newStatus === AvailabilityStatus.ONLINE) newStatus = null;
        if (e.key === "Enter") {
            resetAllStatusStoreExcept(newStatus);
            openedMenuStore.close("profileMenu");
        }
    };
    const handleClick = (newStatus: RequestedStatus | AvailabilityStatus.ONLINE | null) => {
        if (newStatus === AvailabilityStatus.ONLINE) newStatus = null;
        resetAllStatusStoreExcept(newStatus);
        openedMenuStore.close("profileMenu");
    };
</script>

<div>
    <ExternalComponents zone="availabilityStatus" />

    <HeaderMenuItem label={$LL.actionbar.listStatusTitle.enable()} />
    <!-- Some status (silent, in a meeting...) are locking the status bar to only one option -->
    {#if [AvailabilityStatus.LISTENER, AvailabilityStatus.SPEAKER, AvailabilityStatus.JITSI, AvailabilityStatus.LIVEKIT, AvailabilityStatus.BBB, AvailabilityStatus.DENY_PROXIMITY_MEETING, AvailabilityStatus.SILENT, AvailabilityStatus.SOUND_BLOCKED].includes($availabilityStatusStore)}
        <button
            class="status-button group flex py-1 px-0 gap-3 items-center transition-all cursor-pointer text-base font-medium text-mdark w-full pointer-events-auto text-start rounded active:outline-none focus:outline-none"
            aria-label="Текущий статус {getStatusLabel($availabilityStatusStore)}"
        >
            <AvailabilityStatusCircle
                cursorType="pointer"
                position="relative"
                colorHex={getColorHexOfStatus($availabilityStatusStore)}
            />
            <div class="grow text-start leading-4 opacity-50">{getStatusLabel($availabilityStatusStore)}</div>
            <IconCheck class="text-mdark transition-all" />
        </button>
    {:else}
        {#each statusInformation as statusInformationValue (statusInformationValue.AvailabilityStatus)}
            <button
                class="status-button group flex py-1 px-0 gap-3 items-center transition-all cursor-pointer text-base font-medium text-mdark w-full pointer-events-auto text-start rounded active:outline-none focus:outline-none"
                class:justify-end={align === "end"}
                class:disabled={$availabilityStatusStore === statusInformationValue.AvailabilityStatus}
                onkeyup={(e) => {
                    handleKeyPress(e, statusInformationValue.AvailabilityStatus);
                }}
                onclick={(event) => {
                    event.stopPropagation();
                    handleClick(statusInformationValue.AvailabilityStatus);
                }}
                aria-label="Выбрать статус {statusInformationValue.label}"
            >
                <AvailabilityStatusCircle
                    cursorType="pointer"
                    position="relative"
                    colorHex={statusInformationValue.colorHex}
                    isActive={$availabilityStatusStore === statusInformationValue.AvailabilityStatus}
                />
                <div
                    class="text-start leading-4"
                    class:grow={align === "start"}
                    class:opacity-50={$availabilityStatusStore === statusInformationValue.AvailabilityStatus}
                >
                    {statusInformationValue.label}
                </div>
                <IconCheck
                    class="text-mdark {($availabilityStatusStore !== statusInformationValue.AvailabilityStatus
                        ? 'opacity-0 '
                        : '') + 'group-hover:opacity-100 transition-all'}"
                />
            </button>
        {/each}
    {/if}
</div>
